import { ACTIONS } from 'tracker.constants';

const initialState = {
  mobilePhoneNumber: null,
  isMobilePhoneNumberAlreadyVerified: false,
  packageTracker: null,
  shouldLoadQuery: false
};

export default function packageTracking(state = initialState, action) {
  const nextState = { ...state };
  if (action.type === ACTIONS.SAVE_PHONE_NUMBER) {
    nextState.mobilePhoneNumber = action.mobilePhoneNumber;
    nextState.isMobilePhoneNumberAlreadyVerified =
      action.isMobilePhoneNumberAlreadyVerified;
    nextState.packageTracker = action.packageTracker;
    nextState.shouldLoadQuery = action.shouldLoadQuery;
    return nextState;
  }
  return nextState;
}
